// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14LUq","newExpiryDate":"styles_newExpiryDate__3ja0M","footer":"styles_footer__28W0c"};